import { router } from './router'
import store from './store'
import { getToken } from '@/utils/auth'
const whiteList = ['/login', '/register', '/forgetPassword', '/example'];
import { Dialog } from 'vant';
router.beforeEach(async (to, from, next) => {
  webuni.getEnv(function (res) { // eslint-disable-line
    console.log("当前环境是：" + JSON.stringify(res));
    if(!res.miniprogram){
       Dialog.alert({
          title: '提示',
          message: `请到小程序中答题考试`,
          theme: 'round-button',
          showConfirmButton:false
        }).then(() => {
          // on close
        });
      return false;
    }
  });
  // 有token
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    }
    else {
      // 如果没有用户信息，获取用户信息
      if (!store.getters.idCard || !store.getters.userName) {
        // next()
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        store.dispatch('GetInfo',userInfo).then(() => {
          next()
        })
      } else { // 有用户信息
        next()
      }
    }
  } else { // 无token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    }
    else {
      next(`/login`) // 否则全部重定向到登录页
    }
  }
})

// router.afterEach(() => {})
